angular.module('mx.SolutionBuilderAgent').component('mxDataControlPanel', {
	bindings: {
		searchText: '<',
		showAdvancedSearchButton: '<?',
		addButtonItems: '<',
		showSelectionButton: '<',
		onSearch: '&',
		onAdvancedSearchClick: '&',
		onRefreshClick: '&',
		onExportClick: '&',
		autoRefreshConfig: '=?',
		showQueryFilterButton: '<',
		queryFilterOpened: '=?',
		preprocessors: '<',
		parameters: '<',
		showSettingsButton: '<',
		settingsOpened: '=?',
		disableSearch: '<?',
		showExportButton: '<?',
		disableExportButton: '<?',
	},
	controller: MxDataControlPanelCtrl,
	controllerAs: 'vm',
	templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-data-control-panel/mx-data-control-panel.html',
});

MxDataControlPanelCtrl.$inject = [
	'mx.internationalization',
	'mx.shell.KeyboardNavigationService',
	'$scope',
	'$timeout',
	'mx.shell.SidePanelService',
	'mx.shell.ContextService',
	'mx.SolutionBuilderAgent.ContextSelectionService',
	'mx.SolutionBuilderAgent.FavouritesService',
	'mx.shell.NavigationService',
	'mx.shell.EventService',
];

function MxDataControlPanelCtrl(
	i18n,
	keyboardNavigationService,
	$scope,
	$timeout,
	sidePanelService,
	contextService,
	contextSelectionService,
	favouritesService,
	navigationService,
	eventService
) {
	const vm = this;
	vm.sidePanelService = sidePanelService;
	vm.contextSelectionService = contextSelectionService;
	vm.contextService = contextService;
	vm.i18n = i18n;
	vm.favouritesService = favouritesService;
	vm.navigationService = navigationService;

	vm.$onInit = function () {};

	vm.showPanel = function () {
		return vm.preprocessors && vm.preprocessors.pagingPreprocessor && !isNaN(vm.preprocessors.pagingPreprocessor.count) && vm.preprocessors.pagingPreprocessor.count !== 0;
	};

	vm.$postLink = function () {
		keyboardNavigationService.registerKey([
			{
				// Scope: $scope,
				key: 'alt+shift+i',
				// NameInTemplate: 'searchHint',
				description: i18n.get('solutionBuilderAgent.components.mx-data-control-panel.search'),
				onRegister: function () {
					$scope.searchHint = '⇑+i';
				},
				callback: function () {
					$timeout(function () {
						$('mx-data-control-panel input:visible').focus();
					});
				},
			},
			{
				// Scope: $scope,
				key: 'alt+shift+r',
				hint: '⇑+r',
				// NameInTemplate: 'advSearchHint',
				description: i18n.get('solutionBuilderAgent.components.mx-data-control-panel.advancedSearch'),
				onRegister: function () {
					$scope.advSearchHint = '⇑+r';
				},
				callback: function () {
					$timeout(function () {
						const closeSearch = $('.mx-shell-sidebar--close-btn:visible');

						if (closeSearch.length) {
							closeSearch.click();
						} else {
							vm.onAdvancedSearchClick();
						}
					});
				},
			},
		]);
	};

	vm.selectEntireDataset = function () {
		vm.showSelectEntireDataset = false;
		vm.parameters.dataQueryList.selectEntireDataset();
	};

	$scope.$watch('vm.parameters.dataQueryList.allSelectedState', function (allSelectedState) {
		if (!allSelectedState) {
			vm.showSelectEntireDataset = undefined;
		} else {
			vm.showSelectEntireDataset = allSelectedState && !vm.parameters.dataQueryList.wholeDatasetSelected;
		}
	});

	eventService.subscribeTo(
		mx.shell.EventCodes.ObjectSelectionChanged,
		function (e, objectsCollection) {
			if (vm.showSelectEntireDataset !== undefined) {
				if (objectsCollection.length === 0) {
					vm.showSelectEntireDataset = undefined;
				} else {
					vm.showSelectEntireDataset = !vm.parameters.dataQueryList.wholeDatasetSelected;
				}
			}
		},
		$scope
	);

	vm.toggleQueryFiltersPanel = () => {
		vm.queryFilterOpened = !vm.queryFilterOpened;
		setTimeout(() => eventService.dispatchEvent(mx.shell.EventCodes.LayoutChanged));
	};
}
